import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27acf13a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api-list" }
const _hoisted_2 = { class: "ws_mb20" }

import { ref } from 'vue'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const { VUE_APP_PUBLIC_PATH } = process.env

const tableData = ref([
  {
    apiName: '设备服务指令下发',
    url: 'https://api.wstaiot.com/openapi/thing/service/downThingService',
    desc: '设备服务指令下发',
  },
  {
    apiName: '设备服务指令下发状态上报',
    url: 'https://host:port/custInfo/service/reply/downThingService',
    desc: '设备服务指令下发状态上报',
  },
  {
    apiName: '设备服务指令批量下发',
    url: 'https://api.wstaiot.com/openapi/thing/service/downBatchThingService',
    desc: '设备服务指令批量下发',
  },
  {
    apiName: '设备服务指令下发查询状态',
    url: 'https://api.wstaiot.com/openapi/thing/service/queryDownThingService',
    desc: '查询设备服务指令下发状态',
  },
  {
    apiName: '设备自定义原始数据上报',
    url: 'https://host:port/custInfo/event/user/up',
    desc: '设备自定义原始数据上报',
  },
  {
    apiName: '设备属性上报',
    url: 'https://host:port/custInfo/event/device/property/up',
    desc: '设备属性上报',
  },
])

const colunm = [
  {
    type: 'index',
    label: t('C_API.index'),
    width: 80,
  },
  {
    prop: 'apiName',
    label: t('C_API.apiName'),
  },
  {
    prop: 'url',
    label: t('C_API.url'),
  },
  {
    prop: 'desc',
    label: t('C_API.desc'),
  },
]

const toDetail = () => {
  const { protocol, host } = location
  window.open(protocol + '//' + host + VUE_APP_PUBLIC_PATH + '/api.html')
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('C_API.title')), 1),
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('C_API.tip')) + " ", 1),
      _createElementVNode("a", { onClick: toDetail }, _toDisplayString(_ctx.$t('C_API.seeDoc')), 1)
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      class: "ws_mt24",
      stripe: ""
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_el_empty, {
          description: _ctx.$t('C_API.noData')
        }, null, 8, ["description"])
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colunm, (item) => {
          return _createVNode(_component_el_table_column, _mergeProps({
            key: item.prop
          }, {
          ...item,
        }), null, 16)
        }), 64))
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})